import { Tr, Td, Checkbox, Input, Select } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { SurgeryData } from '../../../../../../types/FirestoreUser'

interface Props {
  surgery: string
  uid: string
  surgeryHistory: SurgeryData[]
  setSurgeryHistory: (data: SurgeryData[]) => void
  requiresSide: boolean
}

export default function SurgeryHistoryRow({
  surgery,
  uid,
  surgeryHistory,
  setSurgeryHistory,
  requiresSide,
}: Props) {
  const [isChecked, setIsChecked] = useState(false)
  const [ageOne, setAgeOne] = useState<number | undefined>()
  const [ageTwo, setAgeTwo] = useState<number | undefined>()
  const [ageThree, setAgeThree] = useState<number | undefined>()
  const [ageFour, setAgeFour] = useState<number | undefined>()
  const [side, setSide] = useState<'left' | 'right' | 'both' | null>(null)

  useEffect(() => {
    const existingCondition = surgeryHistory.find(
      (item) => item.surgery === surgery
    )
    if (existingCondition) {
      setIsChecked(true)
      setAgeOne(existingCondition.ageOne || undefined)
      setAgeTwo(existingCondition.ageTwo || undefined)
      setAgeThree(existingCondition.ageThree || undefined)
      setAgeFour(existingCondition.ageFour || undefined)
      setSide(existingCondition.side || null)
    } else {
      setIsChecked(false)
      setAgeOne(undefined)
      setAgeTwo(undefined)
      setAgeThree(undefined)
      setAgeFour(undefined)
      setSide(null)
    }
  }, [surgery, surgeryHistory])

  useEffect(() => {
    const updatedHistory = surgeryHistory.filter(
      (item) => item.surgery !== surgery
    )

    if (isChecked) {
      updatedHistory.push({
        id: surgery,
        surgery,
        ageOne: ageOne === undefined ? null : ageOne,
        ageTwo: ageTwo === undefined ? null : ageTwo,
        ageThree: ageThree === undefined ? null : ageThree,
        ageFour: ageFour === undefined ? null : ageFour,
        side: requiresSide ? side : null,
      })
    }

    setSurgeryHistory(updatedHistory)
  }, [isChecked, ageOne, ageTwo, ageThree, ageFour, side])

  function handleCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
    const checked = e.target.checked
    setIsChecked(checked)
    if (!checked) {
      setAgeOne(undefined)
      setAgeTwo(undefined)
      setAgeThree(undefined)
      setAgeFour(undefined)
      setSide(null)
    }
  }

  return (
    <Tr>
      <Td width='150px' whiteSpace='normal' wordBreak='break-word'>
        {surgery}
      </Td>
      <Td textAlign='left'>
        <Checkbox isChecked={isChecked} onChange={handleCheckboxChange} />
      </Td>
      <Td>
        <Select
          size='sm'
          placeholder='Side'
          isDisabled={!isChecked || !requiresSide}
          value={side || ''}
          onChange={(e) => {
            const value = e.target.value
            setSide(value === '' ? null : (value as 'left' | 'right' | 'both'))
          }}
        >
          <option value='left'>Left</option>
          <option value='right'>Right</option>
          <option value='both'>Both</option>
        </Select>
      </Td>
      <Td>
        <Input
          size='sm'
          type='number'
          placeholder={`Age`}
          isDisabled={!isChecked}
          value={ageOne ?? ''}
          onChange={(e) => {
            const value = e.target.value
            setAgeOne(value === '' ? undefined : Number(value))
          }}
        />
      </Td>
      <Td>
        <Input
          size='sm'
          type='number'
          placeholder={`Age`}
          isDisabled={!isChecked}
          value={ageTwo ?? ''}
          onChange={(e) => {
            const value = e.target.value
            setAgeTwo(value === '' ? undefined : Number(value))
          }}
        />
      </Td>
      <Td>
        <Input
          size='sm'
          type='number'
          placeholder={`Age`}
          isDisabled={!isChecked}
          value={ageThree ?? ''}
          onChange={(e) => {
            const value = e.target.value
            setAgeThree(value === '' ? undefined : Number(value))
          }}
        />
      </Td>
      <Td>
        <Input
          size='sm'
          type='number'
          placeholder={`Age`}
          isDisabled={!isChecked}
          value={ageFour ?? ''}
          onChange={(e) => {
            const value = e.target.value
            setAgeFour(value === '' ? undefined : Number(value))
          }}
        />
      </Td>
    </Tr>
  )
}
